import { Box, Heading } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import DailyMessageDetailsReport from "../../../components/sms/reports/daily/DailyMessageDetails";
import Loader from "../../../components/loader";
import _ from "lodash";
import { Helmet } from "react-helmet";

const DailyMessageDetails = ({
  showFilterForm = true,

  showTitle = 1,
}) => {
  const { loading, messages } = useSelector(
    (state) => state.defaultReducer
  );

  const title = `Message Details`;

  return (
    <Box>
      {showTitle === 1 && (
        <Helmet>
          <title>Daily Message Details</title>
        </Helmet>
      )}
      {showFilterForm ? <FilterForm isMessageDetailsReport={true} /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {!_.isEmpty(messages) ? (
            <>
              <Heading fontSize="34px" color="#222" fontWeight="700">
                {title}
              </Heading>
              <DailyMessageDetailsReport />
            </>
          ) : null}
        </>
      )}
    </Box>
  );
};

export default DailyMessageDetails;
